<template>
    <van-cell-group>
        <van-field v-model="formData.name" label="用户名" placeholder="请输入姓名" input-align="right"
                   :error="formValidate&&!formData.name"
        />
        <div class="btn">
            <van-button type="danger" round size="large" @click="formSave" v-if="!loading">确定</van-button>
            <van-button type="danger" round size="large" v-else>确定中...</van-button>
        </div>
    </van-cell-group>
</template>
<style scoped>
    .btn {
        padding: 0 0.3rem;
        margin-top: 0.3rem
    }

    .van-field__control--right {
        color: #323232;
    }

</style>
<script>
    import {Toast} from 'vant';

    export default {
        name: 'Username',
        comments: {
            Toast
        },

        data: function () {
            return {
                formData: {
                    name: '',
                },
                loading: false,
                formValidate: false,
            }
        },
        filter: {},
        mounted() {
            document.title = '修改用户名'
            this.fetch()
        },
        destroyed() {
        },
        methods: {
            fetch() {
                let that = this;
                this.$api.get('/api/user/getName', {}, (res) => {
                    that.formData.name = res.data
                })
            },


            formSave() {
                let that = this;

                // that.formValidate = true

                if (!that.formData['name']) {
                    that.formValidate = true
                    return;
                }
                that.loading = true

                this.$api.get('/api/user/editName', that.formData, (res) => {
                    this.$router.go(-1)
                    that.loading = false
                    Toast.success("修改成功");
                }, (res) => {
                    Toast(res.msg);
                    that.loading = false
                })
            },

        }
    }
</script>



// WEBPACK FOOTER //
// Username.vue?78ac39aa